module.exports = __webpack_public_path__ + "static/img/fullscreen-image_hero_600_old.4e52b58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/live-hr-advice/fullscreen-image_hero_600_old.png
// module id = KBwc
// module chunks = 0